import { z } from 'zod'

// Base filter schema - common filters used across multiple pages
const baseFilterSchema = z.object({
  search: z.string().optional().default(''),
})

// Church-specific filters
export const churchFilterSchema = baseFilterSchema.extend({
  pastorId: z.array(z.string()).optional().default([]),
  cities: z.array(z.string()).optional().default([]),
  provinces: z.array(z.string()).optional().default([]),
  onlyActives: z.boolean().optional().default(false),
})

// Member-specific filters
export const memberFilterSchema = baseFilterSchema.extend({
  churchId: z.array(z.string()).optional().default([]),
  roles: z.array(z.string()).optional().default([]),
  cities: z.array(z.string()).optional().default([]),
  provinces: z.array(z.string()).optional().default([]),
  onlyActives: z.boolean().optional().default(false),
})

// Donation-specific filters
export const donationFilterSchema = baseFilterSchema.extend({
  churchId: z.array(z.string()).optional().default([]),
  memberId: z.array(z.string()).optional().default([]),
  methods: z.array(z.string()).optional().default([]),
  startDate: z.string().optional().default(''),
  endDate: z.string().optional().default(''),
  status: z.string().optional().default(''),
  onlyActives: z.boolean().optional().default(false),
})

// User-specific filters
export const userFilterSchema = baseFilterSchema.extend({
  churchId: z.array(z.string()).optional().default([]),
  roles: z.array(z.string()).optional().default([]),
  onlyActives: z.boolean().optional().default(false),
})

// Inventory-specific filters
export const inventoryFilterSchema = baseFilterSchema.extend({
  category: z.array(z.string()).optional().default([]),
  inStock: z.boolean().optional().default(false),
})

export const expensesFilterSchema = baseFilterSchema.extend({
  churchId: z.array(z.string()).optional().default([]),
  categoryId: z.array(z.string()).optional().default([]),
  status: z.string().optional().default(''),
  startDate: z.string().optional().default(''),
  endDate: z.string().optional().default(''),
})

// Category-specific filters
export const categoryFilterSchema = baseFilterSchema.extend({})

// Transaction-specific filters
export const transactionFilterSchema = baseFilterSchema.extend({
  churchId: z.array(z.string()).optional().default([]),
  type: z.array(z.string()).optional().default([]),
  startDate: z.string().optional().default(''),
  endDate: z.string().optional().default(''),
})

// Audit log-specific filters
export const auditLogFilterSchema = z.object({
  action: z.string().optional().default(''),
  userId: z.string().optional().default(''),
  startDate: z.string().optional().default(''),
  endDate: z.string().optional().default(''),
})

// Report-specific filters
export const reportFilterSchema = z.object({
  churchId: z.string().optional().default(''),
  memberId: z.string().optional().default(''),
  status: z.string().optional().default(''),
  startDate: z.string().optional().default(''),
  endDate: z.string().optional().default(''),
  year: z.coerce.number().optional().default(new Date().getFullYear() - 1),
})

export const annualSummaryReportsSchema = z.object({
  year: z.coerce.number().min(2000).max(2100).default(new Date().getFullYear() - 1),
})

// Export types
export type ChurchFilter = z.infer<typeof churchFilterSchema>
export type MemberFilter = z.infer<typeof memberFilterSchema>
export type DonationFilter = z.infer<typeof donationFilterSchema>
export type UserFilter = z.infer<typeof userFilterSchema>
export type InventoryFilter = z.infer<typeof inventoryFilterSchema>
export type ExpensesFilter = z.infer<typeof expensesFilterSchema>
export type CategoryFilter = z.infer<typeof categoryFilterSchema>
export type TransactionFilter = z.infer<typeof transactionFilterSchema>
export type AuditLogFilter = z.infer<typeof auditLogFilterSchema>
export type ReportFilter = z.infer<typeof reportFilterSchema>
export type AnnualSummaryReportsFilter = z.infer<
  typeof annualSummaryReportsSchema
>
